
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { ExpansionPanel, TextField } from 'react-md';
import { injectIntl, intlShape } from 'react-intl';
import { withRouter } from 'react-router';
import qs from 'qs';

import { invokeBackendApi } from '../../libs/awsLib';
import ErrorDisplay from '../ErrorDisplay';


export default withRouter(injectIntl(class ViewOnlyPanel extends PureComponent {
  static propTypes = {
    intl: intlShape.isRequired,
    location: PropTypes.object.isRequired,
    objective: PropTypes.string,
    comment: PropTypes.string,
    createTime: PropTypes.string,
    psyName: PropTypes.string,
    onChange: PropTypes.func,
  };
  constructor(props) {
    super(props);

    this.state = {
      objective: props.objective,
      comment: props.comment,
      error: null,
      isEditSubmitLoading: false,
    };
  }

  handleChange = (value, event) => {
    this.setState({
      [event.target.id]: value,
      error: undefined,
    });
  };

  handleOnCancel = () => {
    this.setState({
      objective: this.props.objective,
      comment: this.props.comment,
    });
  }

  handleOnSave = () => {
    this.setState({ isEditSubmitLoading: true, error: '' });
    const { onChange = () => {}, location: { search }, createTime } = this.props;
    const { driver } = qs.parse(search.replace('?', ''));
    const { objective, comment } = this.state;
    const path = createTime ? `/drivers/${driver}/followUps/${createTime}` : `/drivers/${driver}/followUps`;
    invokeBackendApi({ path, method: 'POST', body: { objective, comment } })
      .then(() => {
        this.setState({ isEditSubmitLoading: false, error: null });
        onChange();
      })
      .catch((e) => {
        this.setState({ isEditSubmitLoading: false, error: e.message });
      });
  }

  render() {
    const {
      objective, comment, isEditSubmitLoading, error,
    } = this.state;
    const { intl, createTime = new Date(), psyName } = this.props;
    return (
      <ExpansionPanel
        label={intl.formatDate(createTime, {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
        })}
        secondaryLabel={psyName}
        saveLabel={intl.formatMessage({ id: 'followUp.buttons.save' })}
        cancelLabel={intl.formatMessage({ id: 'followUp.buttons.cancel' })}
        saveProps={{
          swapTheming: true,
          primary: true,
          iconChildren: isEditSubmitLoading ? 'refresh' : 'save',
          disabled: isEditSubmitLoading,
        }}
        cancelProps={{
          swapTheming: true,
          iconChildren: 'cancel',
          disabled: isEditSubmitLoading,
        }}
        defaultExpanded
        onCancel={this.handleOnCancel}
        onSave={this.handleOnSave}
        closeOnCancel={false}
        closeOnSave={false}
      >
        <ErrorDisplay error={error} />

        <TextField
          id="objective"
          label={intl.formatMessage({ id: 'followUp.objective' })}
          placeholder={intl.formatMessage({ id: 'followUp.objectivePlaceholder' })}
          rows={2}
          value={objective}
          onChange={this.handleChange}
          maxLength={4000}
        />
        <TextField
          id="comment"
          label={intl.formatMessage({ id: 'followUp.comment' })}
          placeholder={intl.formatMessage({ id: 'followUp.commentPlaceholder' })}
          rows={2}
          value={comment}
          onChange={this.handleChange}
          maxLength={4000}
        />

      </ExpansionPanel>
    );
  }
}));



// WEBPACK FOOTER //
// ./src/components/FollowUp/EditablePanel.js